export default __webpack_public_path__ + "static/media/setting.f753107c.svg";